export const startUrl = 'https://t.me/';



